import DateTimePicker from './DateTimePicker'

export const DateTimeRange = ({
    start,
    end = start?.clone().add(1, 'h'),
    caption = null,
    className = '',
    startOptions = {},
    endOptions = {},
    onChange = () => {},
    minimumDifferenceInMinutes = 30,
    startOfWeek = 1,
}) => {
    const onStartChange = start => {
        if (start.clone().add(minimumDifferenceInMinutes, 'm').isSameOrAfter(end))
            end = start.clone().add(minimumDifferenceInMinutes, 'm')

        onChange(start, end)
    }

    const onEndChange = end => {
        if (end.clone().subtract(minimumDifferenceInMinutes, 'm').isSameOrBefore(start))
            start = end.clone().subtract(minimumDifferenceInMinutes, 'm')

        onChange(start, end)
    }
    return (
        <div className="date-time-range row">
            <div className="col-6 align-self-md-end">
                <DateTimePicker startOfWeek={startOfWeek} value={start} onChange={onStartChange} {...startOptions} />
            </div>
            <div className="col-6 align-self-md-end pl-0 pl-md-3">
                <DateTimePicker startOfWeek={startOfWeek} value={end} onChange={onEndChange} {...endOptions} />
            </div>
        </div>
    )
}

DateTimeRange.propTypes = {
    startOfWeek: PropTypes.number.isRequired,
    // moment object
    start: PropTypes.shape({}).isRequired,
    startOptions: PropTypes.shape({
        // props passed to DatePicker
        datePickerOptions: PropTypes.shape({}),
        // props passed to TimePicker
        timePickerOptions: PropTypes.shape({}),
    }),
    endOptions: PropTypes.shape({
        datePickerOptions: PropTypes.shape({}),
        timePickerOptions: PropTypes.shape({}),
    }),
}

export default DateTimeRange
